import styles from "./Landing.module.css";

interface LandingProps {
  onPlay: (size: "7x7" | "9x9") => void;
}

export function Landing({ onPlay }: LandingProps) {
  return (
    <div className={styles.landing}>
      <h1 className={styles.title}>GRIDDLE</h1>
      <p className={styles.subtitle}>A daily crossword swap puzzle</p>

      <div className={styles.rules}>
        <h2>How to Play</h2>
        <p>
          Unscramble the crossword by swapping letters into their correct
          positions. Tap one letter, then tap another to swap them.
        </p>

        <div className={styles.colors}>
          <div className={styles.colorRow}>
            <span className={`${styles.swatch} ${styles.green}`}>A</span>
            <span>
              <strong>Green</strong> — correct position. Locked in place.
            </span>
          </div>
          <div className={styles.colorRow}>
            <span className={`${styles.swatch} ${styles.yellow}`}>A</span>
            <span>
              <strong>Yellow</strong> — this letter belongs to a word passing
              through this cell, but not in this position.
            </span>
          </div>
          <div className={styles.colorRow}>
            <span className={`${styles.swatch} ${styles.grey}`}>A</span>
            <span>
              <strong>Grey</strong> — this letter belongs to a different word
              elsewhere in the grid.
            </span>
          </div>
        </div>

        <h2>Scoring</h2>
        <p>
          Each puzzle has a target number of swaps. Solve it within the limit
          to earn up to 6 stars. You can keep playing after running out of
          swaps, but your score won't count.
        </p>

        <h2>Daily Puzzles</h2>
        <p>
          A new 7x7 and 9x9 puzzle is available every day. Browse past
          puzzles in the archive. Your progress is saved automatically.
        </p>
      </div>

      <div className={styles.buttons}>
        <button className={styles.playButton} onClick={() => onPlay("7x7")}>
          Play 7x7
        </button>
        <button
          className={styles.playButtonAlt}
          onClick={() => onPlay("9x9")}
        >
          Play 9x9
        </button>
      </div>
    </div>
  );
}
